import apiRequestActionCreator from './apiRequestActionCreator';

// eslint-disable-next-line import/prefer-default-export
export function fetchVersion() {
    return apiRequestActionCreator({
        actionName: 'VERSION',
        params: {
            baseURL: '',
            url: '/version.json',
        },
    });
}
